import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QuestionGradingPreset } from '@examdojo/models/question';
import { UserStoreModel } from '@examdojo/models/user';
import { ButtonComponent } from '@examdojo/core/button';
import { IconButtonComponent } from '@examdojo/core/icon-button';
import { IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { CurrentReviewHttpModel } from '../../review-item';
import { ReviewSolutionImagesListComponent } from '../solution-images-list/review-solution-images-list.component';
import { ReviewSolutionCaptureDialogService } from './review-solution-capture-dialog.service';

@Component({
  selector: 'dojo-solution-capture-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ion-header>
      <ion-toolbar class="toolbar-with-closing-button !px-2 md:!px-4">
        <div slot="start" class="hidden md:flex">
          <dojo-icon-button (click)="closeModal()" [icon]="'times'" />
        </div>
        <ion-title class="common-ion-title">
          {{ 'examdojo.question.upload_answer' | transloco }}
        </ion-title>
        <div slot="end" class="hidden md:flex md:w-8"></div>
      </ion-toolbar>
    </ion-header>

    <div class="safe-area-bottom">
      <div class="rounded-[1rem] p-0 py-4 md:p-2">
        <dojo-review-solution-images-list [userId]="userId" [reviewSession]="reviewSession" />

        <div class="px-4">
          <dojo-button (click)="saveImages()">
            {{ 'examdojo.continue' | transloco }}
          </dojo-button>
        </div>
      </div>
    </div>
  `,
  imports: [
    ReviewSolutionImagesListComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    ButtonComponent,
    IconButtonComponent,
    TranslocoPipe,
    IconButtonComponent,
  ],
})
export class ReviewSolutionCaptureDialogComponent {
  constructor(private readonly solutionCaptureDialogService: ReviewSolutionCaptureDialogService) {}

  @Input({ required: true }) userId!: UserStoreModel['id'];
  @Input({ required: true }) reviewSession!: CurrentReviewHttpModel['review_session'];

  readonly QuestionGradingPreset = QuestionGradingPreset;

  closeModal() {
    this.solutionCaptureDialogService.dismiss(false);
  }

  saveImages() {
    this.solutionCaptureDialogService.dismiss(true);
  }

  gradeWithPreset(preset: QuestionGradingPreset) {
    this.solutionCaptureDialogService.dismiss(preset);
  }
}
